// extracted by mini-css-extract-plugin
export default {"close_button":"modal_close_button__e+nA1","content":"modal_content__nrtR0","fade":"modal_fade__2jxyJ","h1":"modal_h1__hy1Ra"};